import { useEffect, useState } from 'react'

import { ApiError, api } from '../api'
import type { AccessResponse } from '../../contracts/api'
import './paywall.css'

/**
 * Покупка. Показывается ТОЛЬКО после того, как человек уже получил настоящий
 * результат: печать и первое пересечение бесплатны всегда — это правило из
 * концепции, а не настройка.
 *
 * Пока цены не подтверждены, оплата выключена флагом на сервере: кнопка честно
 * говорит об этом, а не ведёт в никуда.
 */
export function Paywall({ reason }: { reason?: string }) {
  const [state, setState] = useState<AccessResponse | null>(null)
  const [busy, setBusy] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    api
      .get<AccessResponse>('/api/access')
      .then(setState)
      .catch(() => undefined)
  }, [])

  if (!state) return null
  if (state.access.fullAtlas && state.access.subscribed) return null

  async function buy(productKey: string): Promise<void> {
    setBusy(productKey)
    setError('')
    try {
      const { payUrl } = await api.post<{ payUrl: string }>('/api/payments/create', { productKey })
      window.location.href = payUrl
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : 'Оплата пока недоступна')
    } finally {
      setBusy('')
    }
  }

  return (
    <div className="paywall">
      {reason && <div className="paywall-reason">{reason}</div>}
      {state.products.map((product) => (
        <div className="card paywall-card" key={product.key}>
          <div className="paywall-head">
            <div>
              <div className="ttl">{product.title}</div>
              <div className="note">{product.note}</div>
            </div>
            <div className="paywall-price">{product.priceRub} ₽</div>
          </div>
          <button
            type="button"
            className="btn btn-gold paywall-buy"
            disabled={!state.paymentsEnabled || busy === product.key}
            onClick={() => void buy(product.key)}
          >
            {state.paymentsEnabled ? (busy === product.key ? 'Открываем оплату…' : 'Купить') : 'Скоро откроем'}
          </button>
        </div>
      ))}
      {error && <div className="field-warn">{error}</div>}
      <div className="paywall-legal">
        Нажимая «Купить», ты принимаешь условия{' '}
        <a href="https://pay.xkuragax.ru/oferta" target="_blank" rel="noreferrer">
          оферты
        </a>{' '}
        и{' '}
        <a href="https://pay.xkuragax.ru/privacy" target="_blank" rel="noreferrer">
          политику обработки данных
        </a>
        .
      </div>
    </div>
  )
}
